import { BaseModel } from "sjs-base-model";

export default class DatiEconomiciModel extends BaseModel {
    public readonly retribNettaRAP: number = 0;
    public readonly indennFisseNetteRAP: number = 0;
    public readonly totaleIrpef: number = 0;
    public readonly assegniAlimentari: number = 0;
    public readonly debitiStato: number = 0;
    public readonly pignoramenti: number = 0;
    public readonly numeroPignoramenti: number = 0;
    public readonly prestitiConcessi: string = "";
    public readonly cessioniConcesse: string = "";
    public readonly altreRitenute: number = 0;
    public readonly totaleRitenute: number = 0;
    public readonly stipendioFissoNettoMensile: number = 0;
    public readonly quintoStipendio: number = 0;

    constructor(data: Partial<DatiEconomiciModel>) {
        super();

        this.update(data);
    }
}
